import type { z } from 'zod';

const safeJsonParse = (jsonString: string, defaultValue: unknown) => {
  try {
    return JSON.parse(jsonString) as unknown;
  } catch {
    return defaultValue;
  }
};

export const parseJsonString =
  <SchemaType extends z.ZodTypeAny>(schema: SchemaType, defaultValue: SchemaType['_output']) =>
  (jsonString: string | null): SchemaType['_output'] => {
    if (!jsonString) return defaultValue;
    const value = safeJsonParse(jsonString, defaultValue);
    const result = schema.safeParse(value);
    if (result.success) return result.data;
    return defaultValue;
  };
